<template>
  <div
      class="d-flex justify-start align-center body-regular small warning800Color--text flex-nowrap"
      t-data="warning-decimal"
    >
      <v-img
        aspect-ratio="1"
        class="value-message-icon mt-0 mr-1 ml-1"
        max-height="16px"
        max-width="16px"
        src="/images/icons/info-warning-icon.png"
      ></v-img>
      <p class="mb-0">
        {{ message }}
      </p>
    </div>
</template>

<script>
export default {
  name: 'WarningDecimal',
  props: {
    message: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
</style>
